import $ from 'jquery';
import config from '../../../config';

// Get Employee
export function get_employee( id ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'employee.edit/',
			data: {
                method: 'GET_PRINT_EMPLOYEE_EDIT',
                user_id: id
            }
		})
		.then(function (response) {
			dispatch({
				type: "GET_PRINT_EMPLOYEE_EDIT",
				print: response
			})
		})

	}
}

export function get_asset( asset_id ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'print/',
			data: {
                method: 'GET_PRINT_ASSET',
                asset_id: asset_id
            }
		})
		.then(function (response) {
			dispatch({
				type: "GET_PRINT_ASSET",
				print: response
			})
		})

	}
}

export function get_travel( travel_id ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'print/',
			data: {
                method: 'GET_PRINT_TRAVEL',
                travel_id: travel_id
            }
		})
		.then(function (response) {
			dispatch({
				type: "GET_PRINT_TRAVEL",
				print: response
			})
		})

	}
}

export function get_letter( letter_id ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'print/',
			data: {
                method: 'GET_PRINT_LETTER',
                letter_id: letter_id
            }
		})
		.then(function (response) {
			dispatch({
				type: "GET_PRINT_LETTER",
				print: response
			})
		})

	}
}

export function get_expcertificate( user_id ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'print/',
			data: {
                method: 'GET_EXP_CERTIFICATE',
                user_id: user_id
            }
		})
		.then(function (response) {
			dispatch({
				type: "GET_EXP_CERTIFICATE",
				print: response
			})
		})

	}
}

export function get_exitinterview( user_id ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'print/',
			data: {
                method: 'GET_EXIT_INTERVIEW',
                user_id: user_id
            }
		})
		.then(function (response) {
			dispatch({
				type: "GET_EXIT_INTERVIEW",
				print: response
			})
		})

	}
}

export function get_summary( user_id, until_date ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'summary/',
			data: {
                method: 'GET_SUMMARY_ANNUAL_LEAVE_BY_DATE',
                user: user_id,
				until_date: until_date
            }
		})
		.then(function (response) {
			dispatch({
				type: "GET_LETTER_SUMMARY_ANNUAL_LEAVE",
				print: response
			})
		})

	}
}



// WEBPACK FOOTER //
// ./src/pages/prints/actions/print.action.js